var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value > 0)?_c('span',{staticStyle:{"display":"flex"}},[_c('span',{class:'reaction-icon material-icons reaction-icon-' + _vm.icon},[_vm._v(_vm._s(_vm.icon))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }